import { useGetEvaluationReport } from "@/api/console/evaluation-reports/useGetEvaluationReport";
import AdminContentContainer from "@/components/AdminContentContainer";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import BottomBar from "@/components/BottomBar";
import LoadingScreen from "@/components/Loading";
import {
  EvaluationReport,
  evaluationReportSchema,
} from "@/schema/console/evaluation-reports/EvaluationReport";
import CompanyCard from "@/src/_components/CompanyCard";
import ButtonGroup from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/evaluate/_components/ButtonGroup";
import AchievementCard from "@/src/console/(auth)/_components/EvaluationReport/AchievementCard/AchievementCard";
import AssessmentDetailCard from "@/src/console/(auth)/_components/EvaluationReport/AssessmentDetailCard/AssessmentDetailCard";
import SdgIndicatorCard from "@/src/console/(auth)/_components/EvaluationReport/SdgIndicatorCard/SdgIndicatorCard";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

function EvaluateReport() {
  const { t } = useTranslation();
  const { id = "" } = useParams();

  const location = useLocation();

  const breadcrumbs = [
    {
      name: t("check-submissions"),
      href: "/console/check-submissions",
    },
    {
      name: t("evaluate"),
      href: location.pathname,
    },
  ];

  const { data, isLoading } = useGetEvaluationReport(id, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
  });

  const methods = useForm<EvaluationReport>({
    resolver: zodResolver(evaluationReportSchema),
    values: data?.data,
  });

  if (!data || isLoading) return <LoadingScreen />;

  const evaluationReport = data.data;
  const {
    company,
    result_index: { sdg_goal_results, sdg_score },
  } = evaluationReport;
  const showSdg = sdg_score != null && sdg_goal_results.length > 0;

  return (
    <FormProvider {...methods}>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <AdminContentContainer
        bottomBar={
          <BottomBar backLink={`/console/check-submissions`}>
            <ButtonGroup id={id} evaluationReport={evaluationReport} />
          </BottomBar>
        }
      >
        <div className="p-6 pt-8 flex flex-col gap-2 bg-white shadow border-y">
          <p className="text-2xl font-bold">{t("create-report-title")}</p>
          <p className=" text-cool-gray-700 text-sm font-normal">
            {t("check-automatic-scoring-message")}
          </p>
        </div>
        <div className="mx-6 my-8 flex flex-col space-y-8">
          <CompanyCard company={company} />
          {/* <TotalScoreCard score={score} /> */}
          {showSdg && (
            <AchievementCard
              score={sdg_score}
              sdgGoalResults={sdg_goal_results}
            />
          )}
          {showSdg && <SdgIndicatorCard />}
          <AssessmentDetailCard />
        </div>
      </AdminContentContainer>
    </FormProvider>
  );
}

export default EvaluateReport;
